import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import CatalogList from '../../components/DashBoard/CatalogList/CatalogList'
import Meta from '../../components/Helmet/Meta'
import SideBarComponents from '../../components/SideBar/SideBarComponents'
import './dashboard.css'

const CatalogListScreendas = () => {
    return (
        <div   className="main"  fluid >
            <Meta
                title=" | Admin Users"
            />
            <Container fluid>
                <Row>
                    <Col md={3}>
                        <h4> </h4>
                    </Col>
                    <Col md={9}>
                        <h4 > liste Catalog </h4>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <SideBarComponents />
                    </Col>
                    <Col md={9}>
                        <CatalogList />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default CatalogListScreendas
